"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginMain = void 0;
var main_1 = require("./main");
Object.defineProperty(exports, "LoginMain", { enumerable: true, get: function () { return main_1.Main; } });
